// eslint-disable-next-line import/prefer-default-export
export function capitalize(text) {
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : null;
}
